<div class="form-group" [formGroup]="customFormGroup">
  <div [class]="isSwitch ? 'form-switch form-check' : 'form-check'">
    @if (!readonly) {
      <input class="form-check-input"
             [id]="id"
             [formControlName]="id"
             type="checkbox"
             [attr.role]="isSwitch ? 'switch' : 'checkbox'"
             [placeholder]="placeholder"
             (change)="triggerOnChange($event)"
      />
    } @else {
      <input class="form-check-input"
             [id]="id"
             [formControlName]="id"
             type="checkbox"
             [attr.role]="isSwitch ? 'switch' : 'checkbox'"
             [placeholder]="placeholder"
      />
    }
    <label class="form-check-label checkbox-container" [for]="id" [id]="'sfklabel-'+id">
      <p [innerHTML]="label"></p>
    </label>
    <fa-icon class="infoIcon"
             *ngIf="!!infoText && infoText.length > 0"
             [icon]="faInfo"
             [title]="infoText"
             data-cy="custom-info"
    ></fa-icon>
  </div>
  @if(!!infoTextBelowInput && infoTextBelowInput.length > 0) {
    <p>{{ infoTextBelowInput }}</p>
  }
</div>
